<template>
  <div class="takeWay">
    <el-form ref="takeWay_form" :model="list2form" :rules="rules" label-position="left" label-width="72px" :show-message="false" :hide-required-asterisk="true">
      <div class="item" v-for="(item, index) in list" :key="item.drugWayId">
        <div class="header">
          <span class="header_label">取药方式{{ index + 1 }}</span>
          <el-popconfirm
            :ref="`takeWay_custom_popconfirm_${index}`"
            class="custom_popconfirm"
            title="是否确定删除该取药方式？"
            @confirm="deleteTakeWay(item.drugWayId)">
            <el-button slot="reference" v-if="canDeleteTakeWay(item.drugWayId) && item.status !== 1 && !(chargeFlag && item.deliveryAmount > 0) && list.length > 1" class="header_delBtn" type="text" icon="el-icon-delete"></el-button>
          </el-popconfirm>
        </div>
        <div class="form_list">
          <el-form-item label="处理时间" :prop="`list[${index}].handlingTime`" :rules="rules.handlingTime">
            <el-date-picker
              class="form_input"
              v-model="item.handlingTime"
              :picker-options="handlingTimePickerOptions"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择处理时间"
              :disabled="!(item.takeWayEdit&&item.handleTimeEdit)">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="处理医馆" :prop="`list[${index}].transferDeptId`" :rules="rules.transferDeptId">
            <el-select class="form_input" v-model="item.transferDeptId" placeholder="选择" :disabled="!(item.takeWayEdit&&item.handleDeptEdit)" @change="transferDeptChange(item)">
              <el-option
                v-for="dept in hospitalList"
                :key="dept.deptId"
                :label="dept.deptName"
                :value="dept.deptId">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="取药信息" :prop="`list[${index}].deliveryMemberId`" :rules="checkDelivery(item)">
            <el-radio-group v-model="item.deliveryWay" @input="deliveryWayChange(item)">
              <el-radio :label="0" :disabled="!(item.takeWayEdit&&item.deliveryWaySelfEdit) || (chargeFlag && item.deliveryAmount > 0)">自提</el-radio>
              <el-radio :label="1" :disabled="!(item.takeWayEdit&&item.deliveryWayEdit) || (chargeFlag && item.deliveryAmount > 0)">配送</el-radio>
            </el-radio-group>
            <div v-show="item.deliveryWay === 1" :class="{ form_address: true, form_address_placeholder: !item.deliveryMemberId, form_address_disabled: !(item.takeWayEdit&&item.deliveryEdit) }" @click="expressDialogOpen(item)" v-html="item.deliveryMemberId ? item.deliveryMemberValue : '请选择收货地址'"></div>
          </el-form-item>
          <el-form-item v-show="item.deliveryWay === 1 && item.chargeWay === 1" :prop="`list[${index}].deliveryAmount`" :rules="checkDeliveryAmount(item)">
            <template slot="label">
              <div class="expressPrice_label">
                <span>快递费</span>
                <el-tooltip popper-class="custom_tooltip" content="选择该取药方式的配方单快递费合计" placement="top">
                  <i class="el-icon-question expressPrice_label_icon"></i>
                </el-tooltip>
              </div>
            </template>
            <div class="expressPrice_content">
              <el-input
                class="form_input form_input_expressPrice"
                v-model="item.deliveryAmount"
                placeholder="请输入"
                oninput="if(isNaN(value)) { value = null } if( value.indexOf('.') > 0){ value = value.slice(0,value.indexOf('.')+3) } else if ( value.indexOf('.') === 0 ) { value = null }"
                @blur="deliveryAmountBlur(item)"
                :disabled="!(item.takeWayEdit&&item.deliveryAmountEdit) || chargeFlag">
                <span slot="prefix">￥</span>
                <el-button slot="append" @click="countDeliveryPrice(item.drugWayId)" :disabled="!(item.takeWayEdit&&item.deliveryAmountEdit) || chargeFlag">刷新</el-button>
              </el-input>
              <div v-if="item.status === 1" class="expressPrice_refund">已退</div>
            </div>
          </el-form-item>
        </div>
      </div>
    </el-form>
    <el-button class="takeWay_addBtn" icon="el-icon-plus" @click="addTakeWay">新增取药方式</el-button>

    <!-- 快递信息 -->
    <el-dialog
      title="快递信息"
      :visible.sync="express.visible"
      class="express_dialog"
      width="485px"
      append-to-body
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="expressDialogClose">
      <el-form ref="express_form" :model="express.form" :rules="express.rules" label-width="100px" :show-message="false">
        <el-form-item class="express_form_item" label="收货地址：" prop="deliveryMemberId" required>
          <el-popover
            ref="express_address_popover"
            popper-class="custom_popover_nopadding"
            placement="bottom"
            width="330"
            trigger="click">
            <div class="express_address_list">
              <div
                v-for="item in express.addressList"
                :key="item.deliveryMemberId"
                class="express_address_item"
                @click="expressAddressSelect(item)">
                <div class="address_info">
                  <div class="address_info_base">
                    <div class="address_info_name">{{ item.consigneeName }}</div>
                    <div class="address_info_phone">{{ item.phone }}</div>
                    <el-button type="text" class="address_info_edit" @click.stop="receivingInfoDialogOpen(item)">修改</el-button>
                  </div>
                  <div class="address_info_detail">{{ `${item.provinceName}${item.cityName}${item.regionName}${item.scopeName || ''}${item.detailedAddress}` }}</div>
                </div>
                <div class="address_mark">
                  <span v-show="express.form.deliveryMemberId === item.deliveryMemberId" class="el-icon-check address_icon"></span>
                </div>
              </div>
              <div class="express_address_add" @click="receivingInfoDialogOpen()">添加收货地址</div>
            </div>
            <div slot="reference" :class="{ express_address_input: true, express_address_placeholder: !express.form.deliveryMemberId }" v-html="express.form.deliveryMemberId ? express.form.deliveryMemberValue : '请选择收货地址'"></div>
          </el-popover>
        </el-form-item>
        <el-form-item class="express_form_item" label="配送公司：" required>
          <div class="express_row">
            <div class="express_col">
              <el-form-item prop="companyName">
                <el-select class="form_input" v-model="express.form.companyName" placeholder="选择">
                  <el-option
                    v-for="(item, index) in express.companyList"
                    :key="index"
                    :label="item.name"
                    :value="item.name">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="express_col">
              <el-form-item prop="chargeWay">
                <el-select class="form_input" v-model="express.form.chargeWay" placeholder="选择">
                  <el-option
                    v-for="(item, index) in express.payWayList"
                    :key="index"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="expressDialogClose">取 消</el-button>
        <el-button type="primary" @click="expressDialogSubmit">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 地址维护 -->
    <el-dialog
      title="修改收货地址"
      :visible.sync="receivingInfo.visible"
      class="express_dialog"
      width="445px"
      append-to-body
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="receivingInfoDialogClose">
      <el-form ref="receivingInfo_form" label-width="100px" :model="receivingInfo.form" :rules="receivingInfo.rules" :show-message="false">
        <el-form-item class="express_form_item" label="收件人：" prop="consigneeName" required>
          <el-input class="form_input" v-model="receivingInfo.form.consigneeName" placeholder="请输入收件人姓名"></el-input>
        </el-form-item>
        <el-form-item class="express_form_item" label="手机号码：" prop="phone" required>
          <el-input class="form_input" v-model="receivingInfo.form.phone" placeholder="请输入收件人手机号码"></el-input>
        </el-form-item>
        <el-form-item class="express_form_item" label="配送区域：" prop="region" required>
          <el-cascader class="form_input" v-model="receivingInfo.form.region" :props="{ label: 'areaName', value: 'areaCode' }" :options="receivingInfo.areaList" placeholder="请选择省/市/区县"></el-cascader>
        </el-form-item>
        <el-form-item class="express_form_item" label="详细地址：" prop="detailedAddress" required>
          <el-input class="form_input" type="textarea" :autosize="{ minRows: 1, maxRows: 3 }" resize="none" v-model="receivingInfo.form.detailedAddress" placeholder="请输入详细地址"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="receivingInfo_footer">
        <div class="receivingInfo_footer_left">
          <el-popconfirm
            class="custom_popconfirm"
            title="是否确定删除该地址？"
            @confirm="receivingInfoDelete(receivingInfo.form.deliveryMemberId)">
            <el-button slot="reference" v-show="receivingInfo.form.deliveryMemberId" plain icon="el-icon-delete"></el-button>
          </el-popconfirm>
        </div>
        <div class="receivingInfo_footer_right">
          <el-button @click="receivingInfoDialogClose">取 消</el-button>
          <el-button type="primary" @click="receivingInfoDialogSubmit">确 定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { addressAdd, addressList, addressEdit, deleteDelivery } from '@/api/address';
  import { getCompany, deliveryPrice } from '@/api/delivery';
  import { getDrugCenterList } from '@/api/hospital';
  import { validatePhone } from "@/utils/regexp";
  export default{
    name: 'TakeWay',
    props: {
      orderId: {
        type: [String, Number],
        default: ''
      },
      patientInfo: {
        type: Object,
        default: function() {
          return {
            patientId: ''
          }
        }
      },
      chargeFlag: {
        type: Boolean,
        default: false
      },
      prescriptionList: {
        type: Array,
        default: function() {
          return []
        }
      },
      list: {
        type: Array,
        default: function() {
          return []
        }
      }
    },
    data() {
      return {
        rules: {
          handlingTime: [{ required: true, trigger: 'change' }],
          transferDeptId: [{ required: true, trigger: 'change' }]
        },
        handlingTimePickerOptions: {
          disabledDate: function(date) {
            const nowDate = new Date(date).Format('yyyy-MM-dd');
            const toDayDate = new Date().Format('yyyy-MM-dd');
            return nowDate < toDayDate;
          }
        },
        hospitalList: [],
        express: {
          visible: false,
          takeWayId: '',
          addressList: [],
          companyList: [],
          payWayList: [
            { label: '寄付', value: 1 },
            { label: '到付', value: 0 }
          ],
          rules: {
            deliveryMemberId: [{ required: true, trigger: 'change' }],
            companyName: [{ required: true, trigger: 'change' }],
            chargeWay: [{ required: true, trigger: 'change' }],
          },
          form: {
            deliveryMemberId: '',
            deliveryMemberValue: '',
            provinceId: '',
            cityId: '',
            regionId: '',
            detailedAddress: '',
            companyName: '顺丰同城',
            chargeWay: 1
          }
        },
        receivingInfo: {
          visible: false,
          areaList: [],
          rules: {
            consigneeName: [{ required: true, trigger: 'blur' }],
            phone: [{ required: true, validator: validatePhone, trigger: 'blur' }],
            region: [{ required: true, trigger: 'change' }],
            detailedAddress: [{ required: true, trigger: 'blur' }],
          },
          form: {
            deliveryMemberId: '',
            consigneeName: '',
            phone: '',
            region: [],
            detailedAddress: ''
          }
        }
      }
    },
    computed: {
      list2form() {
        return {
          list: this.list
        }
      },
      // 取药方式可删除
      canDeleteTakeWay() {
        return (drugWayId) => {
          let status = true;
          this.prescriptionList.forEach(v1 => {
            v1.prescriptionPaymentVOS.forEach(v2 => {
              if (v2.drugWayId === drugWayId && v2.status !== 0) {
                status = false;
              }
            })
          })
          return status
        }
      }
    },
    created() {
      this.getHospitalList()
    },
    methods: {
      // 获取处理医馆
      getHospitalList() {
        getDrugCenterList({ curDeptId: sessionStorage.getItem('deptId') }).then(res => {
          if (res.code === 200) {
            this.hospitalList = res.data || []
          } else {
            this.$message.error(res.msg)
          }
        })
      },
      // 取药信息校验
      checkDelivery(row) {
        return [{
          validator: (rule, value, callback) => {
            if (row.deliveryWay === 1 && ['', null, undefined].includes(row.deliveryMemberId)) {
              callback(new Error())
            } else {
              callback()
            }
          },
          trigger: 'change'
        }]
      },
      // 快递费校验
      checkDeliveryAmount(row) {
        return [{
          validator: (rule, value, callback) => {
            if (row.deliveryWay === 1 && row.chargeWay === 1 && ['', null, undefined].includes(row.deliveryAmount)) {
              callback(new Error())
            } else {
              callback()
            }
          },
          trigger: 'blur'
        }]
      },
      // 取药方式表单校验
      validate() {
        return this.$refs['takeWay_form'].validate().catch(() => false);
      },
      // 生成处理信息id
      generateId() {
        const generator = () => {
          let drugWayId = `${this.orderId}_${new Date().getTime()}`;
          const hasIndex = this.list.findIndex(v => { return v.drugWayId === drugWayId });
          if (hasIndex === -1) {
            return drugWayId
          } else {
            return generator()
          }
        }
        const drugWayId = generator();
        return drugWayId;
      },
      // 新增取药方式
      addTakeWay() {
        const drugWayId = this.generateId();
        this.list.push({
          drugWayId: drugWayId,
          handlingTime: new Date().Format('yyyy-MM-dd'),
          transferDeptId: '',
          transferDeptName: '',
          deliveryWay: 0,
          deliveryMemberId: '',
          deliveryMemberValue: '',
          delivery: {
            provinceId: '',
            cityId: '',
            regionId: '',
            detailedAddress: ''
          },
          companyName: '',
          chargeWay: '',
          deliveryAmount: '',
          takeWayEdit: true,
          handleTimeEdit: true,
          handleDeptEdit: true,
          deliveryWaySelfEdit: true,
          deliveryWayEdit: true,
          deliveryEdit: true,
          deliveryAmountEdit: true
        })
      },
      // 删除取药方式
      deleteTakeWay(drugWayId) {
        const index = this.list.findIndex(v => { return v.drugWayId === drugWayId });
        if (index !== -1) {
          this.list.splice(index, 1);
          this.prescriptionList.map(v1 => {
            v1.prescriptionPaymentVOS.map(v2 => {
              if (v2.drugWayId === drugWayId) {
                v2.drugWayId = '';
              }
            })
          })
        }
      },
      // 处理医馆切换
      transferDeptChange(row) {
        row['transferDeptName'] = this.hospitalList.find(v => { return v.deptId === row.transferDeptId })['deptName'];
        if (this.chargeFlag) {
          let useNum = 0;
          const drugWayId = row.drugWayId;
          this.prescriptionList.forEach(v1 => {
            v1.prescriptionPaymentVOS.forEach(v2 => {
              if (v2.status !== 0 && v2.drugWayId === drugWayId) {
                useNum++
              }
            })
          })
          if (useNum > 1) {
            this.$confirm('修改处理医馆将同时影响多个配方单', '提示', {
              confirmButtonText: '确定',
              showCancelButton: false,
              closeOnClickModal: false,
              closeOnPressEscape: false,
              type: 'warning'
            }).then(() => {}).catch(() => {});
          }
        }
      },
      // 取药信息切换
      deliveryWayChange(row) {
        if ([null, undefined].includes(row.delivery)) {
          row.delivery = {}
        }
        row.deliveryMemberId = '';
        row.deliveryMemberValue = '';
        row.delivery.provinceId = '';
        row.delivery.cityId = '';
        row.delivery.regionId = '';
        row.delivery.detailedAddress = '';
        row.companyName = '';
        row.chargeWay = '';
        row.deliveryAmount = '';
        if (row.deliveryWay === 1) {
          row.transferDeptId = 127
          this.expressDialogOpen(row)
        }
        const takeWayIndex = this.list.findIndex(v => { return v.drugWayId === row.drugWayId });
        this.$refs['takeWay_form'].clearValidate([`list[${takeWayIndex}].deliveryMemberId`, `list[${takeWayIndex}].deliveryAmount`]);
        
      },
      // 快递费失焦
      deliveryAmountBlur(item) {
        if (item.deliveryAmount) {
          item.deliveryAmount = Number(item.deliveryAmount)
        }
      },
      // 获取用户收货地址
      async getUserAddress() {
        if (!this.patientInfo.patientId) {
          return false
        };
        const res = await addressList(this.patientInfo.patientId)
        if (res.code === 200) {
          this.express.addressList = res.rows || [];
          if (this.express.form.deliveryMemberId) {
            const address = this.express.addressList.find(v => { return v.deliveryMemberId === this.express.form.deliveryMemberId });
            if (address) {
              this.express.form.deliveryMemberValue = `${address.consigneeName}&emsp;${address.phone}<br>${address.provinceName}${address.cityName}${address.regionName}${address.scopeName || ''}${address.detailedAddress}`;
              this.express.form.provinceId = address.provinceId;
              this.express.form.cityId = address.cityId;
              this.express.form.regionId = address.regionId;
              this.express.form.detailedAddress = address.detailedAddress;
            }
            this.$refs['express_form'].validateField('deliveryMemberId');
          }
        } else {
          this.$message.error(res.msg)
        }
      },
      // 获取配送公司
      async getCompanyList() {
        const res = await getCompany();
        if (res.code === 200) {
          this.express.companyList = res.data || [];
        } else {
          this.$message.error(res.msg)
        }
      },
      // 快递信息弹窗打开
      expressDialogOpen(row) {
        if (!(row.takeWayEdit&&row.deliveryEdit)) {
          return false;
        }
        this.getUserAddress();
        this.getCompanyList();
        this.express.takeWayId = row.drugWayId;
        this.express.form.deliveryMemberId = row.deliveryMemberId;
        this.express.form.deliveryMemberValue = row.deliveryMemberValue;
        this.express.form.provinceId = row.delivery.provinceId;
        this.express.form.cityId = row.delivery.cityId;
        this.express.form.regionId = row.delivery.regionId;
        this.express.form.detailedAddress = row.delivery.detailedAddress;
        this.express.form.companyName = row.companyName || '顺丰同城';
        this.express.form.chargeWay = [null, undefined, ''].includes(row.chargeWay) ? 1 : row.chargeWay;
        this.express.visible = true;
        this.$nextTick(() => {
          this.$refs['express_form'].clearValidate();
        })
      },
      // 快递信息弹窗关闭
      expressDialogClose() {
        this.express.visible = false;
        this.express.takeWayId = '';
        this.express.form.deliveryMemberId = '';
        this.express.form.deliveryMemberValue = '';
        this.express.form.provinceId = '';
        this.express.form.cityId = '';
        this.express.form.regionId = '';
        this.express.form.detailedAddress = '';
        this.express.form.companyName = '顺丰同城';
        this.express.form.chargeWay = 1;
      },
      // 用户地址选择
      expressAddressSelect(row) {
        this.$refs['express_address_popover'].doClose();
        this.express.form.deliveryMemberId = row.deliveryMemberId;
        this.express.form.deliveryMemberValue = `${row.consigneeName}&emsp;${row.phone}<br>${row.provinceName}${row.cityName}${row.regionName}${row.scopeName || ''}${row.detailedAddress}`;
        this.express.form.provinceId = row.provinceId;
        this.express.form.cityId = row.cityId;
        this.express.form.regionId = row.regionId;
        this.express.form.detailedAddress = row.detailedAddress;
        this.$refs['express_form'].validateField('deliveryMemberId');
      },
      // 快递信息弹窗提交
      async expressDialogSubmit() {
        const valid = await this.$refs['express_form'].validate().catch(() => false);
        if (valid) {
          const takeWay = this.list.find(v => { return v.drugWayId === this.express.takeWayId });
          const takeWayIndex = this.list.findIndex(v => { return v.drugWayId === this.express.takeWayId });
          if (takeWay) {
            let text = this.express.form.deliveryMemberValue;
            text = text.replace(/&emsp;/g, '');
            text = text.replace(/<br>/g, '');

            takeWay.deliveryMemberId = this.express.form.deliveryMemberId;
            takeWay.deliveryMemberValue = text;
            takeWay.delivery.provinceId = this.express.form.provinceId;
            takeWay.delivery.cityId = this.express.form.cityId;
            takeWay.delivery.regionId = this.express.form.regionId;
            takeWay.delivery.detailedAddress = this.express.form.detailedAddress;
            takeWay.companyName = this.express.form.companyName;
            takeWay.chargeWay = this.express.form.chargeWay;

            this.countDeliveryPrice(takeWay.drugWayId);
          }
          this.$refs['takeWay_form'].validateField(`list[${takeWayIndex}].deliveryMemberId`);
          this.expressDialogClose();
        }
      },
      // 用户收货信息弹窗打开
      receivingInfoDialogOpen(row) {
        this.receivingInfo.areaList = sessionStorage.getItem('nationalAreaList') && JSON.parse(sessionStorage.getItem('nationalAreaList')) || [];
        if (row) {
          this.receivingInfo.form.deliveryMemberId = row.deliveryMemberId;
          this.receivingInfo.form.consigneeName = row.consigneeName;
          this.receivingInfo.form.phone = row.phone;
          this.receivingInfo.form.region = [row.provinceId, row.cityId, row.regionId];
          this.receivingInfo.form.detailedAddress = row.detailedAddress;
        } else {
          this.receivingInfo.form.consigneeName = this.patientInfo.patientName;
          this.receivingInfo.form.phone = this.patientInfo.phone;
        }
        this.receivingInfo.visible = true;
        this.$nextTick(() => {
          this.$refs['receivingInfo_form'].clearValidate();
        })
      },
      // 用户收货信息弹窗关闭
      receivingInfoDialogClose() {
        this.receivingInfo.visible = false;
        this.receivingInfo.form.deliveryMemberId = '';
        this.receivingInfo.form.consigneeName = '';
        this.receivingInfo.form.phone = '';
        this.receivingInfo.form.region = '';
        this.receivingInfo.form.detailedAddress = '';
      },
      // 用户收货信息弹窗提交
      async receivingInfoDialogSubmit() {
        const valid = await this.$refs['receivingInfo_form'].validate().catch(() => false);
        if (valid) {
          let res = null, text = '';
          const param = {
            patientId: this.patientInfo.patientId,
            deliveryMemberId: this.receivingInfo.form.deliveryMemberId,
            consigneeName: this.receivingInfo.form.consigneeName,
            phone: this.receivingInfo.form.phone,
            provinceId: this.receivingInfo.form.region[0],
            cityId: this.receivingInfo.form.region[1],
            regionId: this.receivingInfo.form.region[2],
            detailedAddress: this.receivingInfo.form.detailedAddress
          }
          if (!this.receivingInfo.form.deliveryMemberId) {
            text = '创建收货地址成功！';
            res = await addressAdd(param);
          } else {
            text = '修改收货地址成功！';
            res = await addressEdit(param);
          }
          if (res.code === 200) {
            this.$message.success(text);
            this.express.form.deliveryMemberId = !this.receivingInfo.form.deliveryMemberId ? res.data : res.data.deliveryMemberId;
            this.getUserAddress();
            this.receivingInfoDialogClose();
          } else {
            this.$message.error(res.msg)
          }
        }
      },
      // 用户收货信息删除
      async receivingInfoDelete(id) {
        const res = await deleteDelivery(id);
        if (res.code === 200) {
          if (this.express.form.deliveryMemberId === id) {
            this.$message.success('删除成功！');
            this.express.form.deliveryMemberId = '';
            this.express.form.deliveryMemberValue = '';
          }
          this.getUserAddress();
          this.receivingInfoDialogClose();
        } else {
          this.$message.error(res.msg)
        }
      },
      // 计算快递费
      countDeliveryPrice(drugWayId) {
        const takeWay = this.list.find(v => { return v.drugWayId === drugWayId });
        if (this.chargeFlag && !takeWay.deliveryAmountEdit) {
          return false;
        }
        if (['', undefined, null].includes(takeWay.deliveryAmount)){
          takeWay.deliveryAmount = 0;
        }
        if (takeWay.chargeWay === 0) {
          takeWay.deliveryAmount = 0;
        } else {
          let weight = 0;
          this.prescriptionList.forEach(v1 => {
            v1.prescriptionPaymentVOS.forEach(v2 => {
              if (v2.drugWayId === drugWayId && v2.deliveryFree === 0) {
                let formulaWeight = 0;
                v2.drugs.forEach(v3 => {
                  if (v3.checkStatus === 1 && v3.isOwned !== 1 && v3.unit === 'g') {
                    formulaWeight = formulaWeight + Number(v3.useDrugNum)
                  }
                })
                weight = weight + formulaWeight * Number(v2.dosage);
              }
            })
          });
          weight = Math.round(weight * 100) / 100;
          const param = {
            deptId: sessionStorage.getItem('deptId'),
            provinceId: takeWay.delivery.provinceId,
            cityId: takeWay.delivery.cityId,
            regionId: takeWay.delivery.regionId,
            companyName: takeWay.companyName,
            weight: weight
          }
          this.$emit('loadingChange', true);
          deliveryPrice(param).then(res => {
            this.$emit('loadingChange', false);
            if (res.code === 200) {
              takeWay.deliveryAmount = res.data || '';
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      }
    }
  }
</script>

<style lang="less" scoped>
  .takeWay{
    width: 100%;
  }

  .item{
    padding: 20px 0 0 0;
    border-top: 1px dashed #D3D3D5;
  }

  .takeWay .item:first-child{
    padding: 0 0 0 0;
    border-top: none;
  }

  .header{
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 20px;
  }

  .header_label{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-weight: bold;
    font-size: 14px;
    color: #000000;
  }

  .header_label::before{
    content: '';
    display: block;
    margin: 0 4px 0 0;
    width: 4px;
    height: 14px;
    background-color: #1890FF;
    border-radius: 7px;
  }

  .header_delBtn{
    font-size: 16px;
    color: #667182;
  }

  .header_delBtn:hover{
    color: #F54A45;
  }

  .form_list{
    margin: 10px 0 0 0;
    overflow: hidden;
  }

  .form_list /deep/ .el-form-item__label,.form_list /deep/ .el-form-item__content{
    line-height: 32px;
    color: #667182;
  }

  .form_list /deep/ .el-form-item{
    margin-bottom: 16px;
  }

  .form_input{
    width: 100%;
  }

  /deep/.is-error .form_input .el-input__inner{
    border-color: #FE8F1F;
  }

  .form_address{
    box-sizing: border-box;
    padding: 6px 12px;
    width: 100%;
    height: 72px;
    line-height: 20px;
    font-size: 14px;
    color: #1f2329;
    background-color: #FFFFFF;
    border: 1px solid #D3D3D5;
    border-radius: 2px;
    overflow-x: hidden;
    overflow-y: auto;
    cursor: pointer;
  }

  .form_list /deep/.is-error .form_address{
    border-color: #FE8F1F;
  }

  .form_address_placeholder{
    color: #A4AFBA;
  }

  .form_address.form_address_disabled{
    background-color: #f8f9f9;
  }

  .expressPrice_content{
    position: relative;
    z-index: 1;
    width: 100%;
  }

  .expressPrice_refund{
    position: absolute;
    z-index: 2;
    top: 7px;
    right: 62px;
    box-sizing: border-box;
    padding: 0 2px;
    height: 18px;
    line-height: 14px;
    font-size: 12px;
    color: #F54A45;
    border: 1px solid #F54A45;
    border-radius: 2px;
  }

  .form_input_expressPrice /deep/ .el-input__inner{
    padding-left: 20px;
  }

  .form_input_expressPrice /deep/ .el-input__prefix{
    display: flex;
    justify-content: center;
    align-items: center;
    color: #000000;
  }

  .expressPrice_label_icon{
    margin: 0 0 0 3px;
    color: #BCC2C8;
  }

  .takeWay_addBtn{
    margin: 8px 0 0 0;
    width: 100%;
    font-size: 14px;
    color: #1890FF;
  }

  .express_dialog /deep/ .el-dialog__body{
    padding: 20px 24px;
  }

  .express_dialog /deep/ .el-form-item__label,.express_dialog /deep/ .el-form-item__content{
    line-height: 32px;
    color: #667182;
  }

  .express_dialog /deep/ .el-dialog__footer{
    padding-top: 4px;
  }

  .express_form_item{
    margin: 0 0 0 0;
  }

  .express_form_item:not(:first-child){
    margin: 20px 0 0 0;
  }

  .express_row{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
  }

  .express_col{
    flex-grow: 1;
  }

  .express_col:not(:first-child) {
    margin: 0 0 0 8px;
  }

  .express_address_input{
    box-sizing: border-box;
    padding: 0 15px;
    width: 100%;
    line-height: 32px;
    color: #1f2329;
    background-color: #FFFFFF;
    border: 1px solid #d3d3d5;
    border-radius: 2px;
  }

  .express_form_item.is-error .express_address_input{
    border-color: #FE8F1F;
  }

  .express_address_placeholder{
    color: #A4AFBA;
  }

  .express_address_list {
    max-height: 360px;
    overflow-x: hidden;
    overflow-y: auto;
  }

  .express_address_item{
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 12px;
    width: 100%;
    border-bottom: 1px solid #E0E0E0;
    cursor: pointer;
  }

  .address_info{
    flex-grow: 1;
  }

  .address_info_base{
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .address_info_name{
    font-weight: bold;
    font-size: 14px;
    color: #000000;
  }

  .address_info_phone{
    margin: 0 0 0 8px;
    font-size: 14px;
    color: #667182;
  }

  .address_info_edit{
    margin: 0 0 0 8px;
    padding: 0;
    font-size: 14px;
    color: #1890FF;
  }

  .address_info_detail{
    margin: 6px 0 0 0;
    font-size: 14px;
    color: #667182;
  }

  .address_mark{
    flex-shrink: 0;
    margin: 0 0 0 8px;
    width: 16px;
    height: 16px;
  }

  .address_icon{
    font-size: 16px;
    color: #1890FF;
  }

  .express_address_add{
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 36px;
    font-size: 14px;
    color: #1890FF;
    cursor: pointer;
  }

  .receivingInfo_footer{
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }

  .receivingInfo_footer_left{
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .receivingInfo_footer_right{
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
</style>
